// Seed data for the Proposal "Setup" step UI; replace with API-backed values later.

// `disabled` chips aren't supported by the backend (only formal | professional |
// technical), so they're shown but not selectable.
export const TONE_OPTIONS = [
  {
    label: "Formal & Compliance",
    description:
      "Precise, requirement-by-requirement writing that foregrounds certifications, risk controls and exact compliance language.",
  },
  {
    label: "Professional & Results",
    description:
      "Confident, outcome-led writing built around metrics, ROI and proven delivery track record.",
  },
  {
    label: "Innovative & Visionary",
    description:
      "Forward-looking writing that emphasises differentiation, technology and bold thinking.",
  },
];

export const DEFAULT_TONE = "Professional & Results";

export const COMPANION_DOCS = [
  {
    id: "cover_letter",
    title: "Cover Letter",
    badge: "Default",
    description: "Personalised letter using your tone & win themes",
  },
  // Submission Checklist is disabled — commented out so it no longer appears as a
  // Companion Documents option. Uncomment to bring it back.
  // {
  //   id: "submission_checklist",
  //   title: "Submission Checklist",
  //   badge: "Default",
  //   description: "Tracks all submission requirements & formats",
  // },
];

export const DEFAULT_COMPANION_DOCS = ["cover_letter"];

export const CUSTOM_INSTRUCTIONS_MAX = 600;

export const RFP_BRIEF = {
  title: "NextGen Infotech — Cloud Modernisation",
  generatedNote: "Docusensa generated brief · updated just now",
  summary:
    "A 3-year engagement to migrate NextGen's on-prem estate to a secure multi-cloud platform, with a phased rollout, 24/7 managed support and strict ISO-27001 compliance. Evaluation is weighted heavily toward technical capability and demonstrable cost reduction.",
  client: "NextGen Infotech",
  due: "Aug 31, 2025",
  source: "NextGen_RFP_v3.pdf · 48 pp",
  scopeOfWork: [
    "Cloud migration of core systems (ERP, HR) and departmental workloads",
    "24/7 help desk and on-site support across 12 departments",
    "Staff training and knowledge transfer",
    "Infrastructure redundancy, backup & disaster recovery",
    "8-month phased implementation with defined SLAs",
  ],
};

// How much prose each section and subsection runs to.
//
// "Concise" is the DEFAULT: it scales the generator's word ceilings down without
// dropping any requirement coverage. "Detailed" is the generator's original
// behaviour, kept as an explicit opt-in for bids that want the fuller treatment.
export const LENGTH_OPTIONS = [
  {
    value: "short",
    label: "Concise",
    description:
      "Tightest writing and the default. Every requirement is still answered, in about half the words — best for page-limited or fast-turnaround bids.",
  },
  {
    value: "long",
    label: "Detailed",
    description:
      "Full depth — the most evidence, examples and design reasoning per section. Choose this when the bid rewards thoroughness over brevity.",
  },
];

export const DEFAULT_LENGTH = "short";
